"use client";

import { usePathname } from "@/i18n/routing";
import styles from "./Snackbar.module.css";
import { clsx } from "@frend-digital/ui";

export const SnackbarWrapper = ({ children }: { children: React.ReactNode }) => {
	const pathname = usePathname();

	const isCheckout = pathname.includes("checkout") && !pathname.includes("summary");

	return (
		<div className={clsx(isCheckout && styles.hideSnackbar, isCheckout && "snackbar-hidden")}>
			{children}
		</div>
	);
};
